import {
	comMapping
} from "@/components/util/Function/comMapping";
import {szBankStorage} from '../../../util/Function/szBankStorage.js'
import {getdata as getdataI} from '../yffygl/xmwd/data.js'
export function getdata() {
	var obj = {
		searchlist: [{
				prop: "nsrmc",
				label: '纳税人名称',
				type: "select",
				selectval:szBankStorage.$getdemoCompany
			},
			{
				prop: "year",
				label: '年度',
				type: "select",
				selectval:szBankStorage.$getYearList()
			},

		],
		searchdata: {
			nsrmc: "",
			year: szBankStorage.$getNowYear()
		},
		headData: [{
				title: "统计大类/项目名称",
				prop: "nsrmc",
				width: 160,
				align: "left",
				custom: true
			},
			{
				title: "金额（数量）",
				prop: "",
				children: [{
						title: "合计",
						width: "80",
						AmountFormat: true,
						align: "right",
						prop: "yibHuowxl13Xse",
						custom: true,
						xmwd_0_1_2:0,
						xmwd_0_1_35:0,
						xmwd_0_1_40:0,
						xmwd_0_1_43:0,
						xmwd_0_1_44:0,
						xmwd_0_1_45:0,
						xmwd_0_1_47:0,
						xmwd_0_1_50:0,
						xmwd_0_1_51:0,
						xmwd_0_1_52:0,
					},
					{
						title: "项目A",
						width: "80",
						AmountFormat: true,
						prop: "tes1",
						custom: true,
						headprop: "tes1_headprop",
						headcustom: true,
						obj:getdataI().tableData,
						xmwd_0_1_2:0,
						xmwd_0_1_35:0,
						xmwd_0_1_40:0,
						xmwd_0_1_43:0,
						xmwd_0_1_44:0,
						xmwd_0_1_45:0,
						xmwd_0_1_47:0,
						xmwd_0_1_50:0,
						xmwd_0_1_51:0,
						xmwd_0_1_52:0,
					},
					{
						title: "项目B",
						width: "80",
						AmountFormat: true,
						prop: "tes2",
						headprop: "tes2_headprop",
						headcustom: true,
						custom: true,
						obj:getdataI().tableData,
						xmwd_0_1_2:0,
						xmwd_0_1_35:0,
						xmwd_0_1_40:0,
						xmwd_0_1_43:0,
						xmwd_0_1_44:0,
						xmwd_0_1_45:0,
						xmwd_0_1_47:0,
						xmwd_0_1_50:0,
						xmwd_0_1_51:0,
						xmwd_0_1_52:0,
					},
					{
						title: "项目C",
						width: "80",
						AmountFormat: true,
						prop: "tes3",
						headprop: "tes3_headprop",
						headcustom: true,
						custom: true,
						obj:getdataI().tableData,
						xmwd_0_1_2:0,
						xmwd_0_1_35:0,
						xmwd_0_1_40:0,
						xmwd_0_1_43:0,
						xmwd_0_1_44:0,
						xmwd_0_1_45:0,
						xmwd_0_1_47:0,
						xmwd_0_1_50:0,
						xmwd_0_1_51:0,
						xmwd_0_1_52:0,
					},
					{
						title: "项目D",
						width: "80",
						AmountFormat: true,
						prop: "tes4",
						headprop: "tes4_headprop",
						headcustom: true,
						custom: true,
						obj:getdataI().tableData,
						xmwd_0_1_2:0,
						xmwd_0_1_35:0,
						xmwd_0_1_40:0,
						xmwd_0_1_43:0,
						xmwd_0_1_44:0,
						xmwd_0_1_45:0,
						xmwd_0_1_47:0,
						xmwd_0_1_50:0,
						xmwd_0_1_51:0,
						xmwd_0_1_52:0,
					},
					{
						title: "项目E",
						width: "80",
						AmountFormat: true,
						prop: "tes5",
						headprop: "tes5_headprop",
						headcustom: true,
						custom: true,
						obj:getdataI().tableData,
						xmwd_0_1_2:0,
						xmwd_0_1_35:0,
						xmwd_0_1_40:0,
						xmwd_0_1_43:0,
						xmwd_0_1_44:0,
						xmwd_0_1_45:0,
						xmwd_0_1_47:0,
						xmwd_0_1_50:0,
						xmwd_0_1_51:0,
						xmwd_0_1_52:0,
					}
				]

			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		headlyData: [{
			title: "序号",
			prop: "xh",
			width: 80,
			custom: true,
		}, {
			title: "项目名称",
			prop: "title",
			width: 160,
			align: "left",
			custom: true,
		}, {
			title: "操作",
			prop: "cz",
			width: "200",
			custom: true,
		}]
	}
	return obj
}
